import type { ICampaignMinimal } from "../../../../types/models/campaign.models.types";
import { usePutHttp } from "../../http.hook";

interface IResponse {
  campaign: ICampaignMinimal;
}

interface IBody {
  endDate: Date;
}

export function useEndCampaignAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/campaigns/:id/end",
  });
}
